(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-3"] && !Shopify.designMode) return;
  try {
    
    const faqTabEls = document.querySelectorAll('[id^="faq-tab"]');
    const faqNavEl = document.querySelector('#faq-navigation');

    faqTabEls.forEach((faqTabEl, index) => {
        // Attribute
        const faqTabName = faqTabEl.getAttribute('data-name');

        // Parser
        const parser = new DOMParser();

        // Create button
        const faqTabBtnString = `<button type="button" class="faq-tab-btn button-axl ${index > 0 ? '' : 'active'}">${faqTabName}</button>`;
        const faqTabBtnEl = parser.parseFromString(faqTabBtnString, 'text/html').body.firstChild;

        faqTabBtnEl.addEventListener('click', () => {
            // Remove active button
            document.querySelectorAll('.faq-tab-btn').forEach(btnEls => {
                btnEls.classList.remove('active')
            });

            // Hide tabs
            faqTabEls.forEach(tabEls => {
                tabEls.style.display = 'none'
            });

            // Add active button & show tab
            faqTabBtnEl.classList.add('active');
            faqTabEl.style.display = '';
        });

        // Create list item
        const faqTabListItemString = '<li class="grow shrink-0"></li>';
        const faqTabListItemEl = parser.parseFromString(faqTabListItemString, 'text/html').body.firstChild;

        faqTabListItemEl.append(faqTabBtnEl);

        // Insert button in DOM
        faqNavEl.append(faqTabListItemEl);

        if (index > 0) {
            faqTabEl.style.display = 'none';
        }
    });

  } catch(e) { console.error(e); }
})();
})();
